import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

// 账户相关
const team = new Restful(project, 'team')

team.webGet = function(data) {
  const url = project + 'team/website'
  return http.get(url, data).then(res => {
    return res
  })
}
export default team
